<template>
  <div class="" style="display: inline-block">
    <van-popover
      theme="dark"
      v-model="showPopover"
      trigger="click"
      v-bind="popoverProps"
    >
      <template #default>
        <div class="content" :style="{ maxWidth: maxW }">
          <template v-if="!Array.isArray(tipWord)">
            {{ tipWord }}
          </template>
          <template v-else>
            <div v-for="(i, index) in tipWord" :key="index">{{ i }}</div>
          </template>
        </div>
      </template>
      <template #reference>
        <van-icon name="info" class="gray" />
      </template>
    </van-popover>
  </div>
</template>

<script>
export default {
  name: 'TipPop',
  props: {
    tipWord: {
      type: [String, Array],
      default: '',
    },
    maxW: {
      type: String,
      default: '33.33vw',
    },
    popoverProps: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      showPopover: false,
    }
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.content {
  padding: 10px;
  // max-width: 33.33vw;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 22px;
}
.gray {
  color: #dedfe5;
}
</style>
